import { call, put, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACT from "./actions";
import { getPriceApi,verifyWalletApi } from "helpers/transak_api_helper";
import {errorMsg, successMsg} from "helpers/toastr";

function* getPriceSaga({ payload: { data, callback } }) {

  try {
    const response = yield call(getPriceApi, data);
    callback && callback(response);
    if (response?.response?.data?.error?.message) {
       return yield put(ACT.getPriceFailed(response.message));
    }
    yield put(ACT.getPriceSuccessful(response?.data?.response));
  } catch (error) {
    yield put(ACT.getPriceFailed(error));
  }
}


function* verifyWalletSaga({ payload: { data, callback } }) {

  try {
    const response = yield call(verifyWalletApi, data);
    callback && callback(response);
    if (response.status == "failure") {
      return yield put(ACT.verifyWalletFailed(response.message));
    }
    yield put(ACT.verifyWalletSuccessful(response));
  } catch (error) {
    yield put(ACT.verifyWalletFailed(error));
  }
}


function* priceSaga() {
  yield takeEvery(CONST.GET_PRICE, getPriceSaga);
  yield takeEvery(CONST.VERIFY_WALLET, verifyWalletSaga);

}

export default priceSaga;
